import { render, staticRenderFns } from "./janjiDatengModal.vue?vue&type=template&id=560ef316"
import script from "./janjiDatengModal.vue?vue&type=script&lang=js"
export * from "./janjiDatengModal.vue?vue&type=script&lang=js"
import style0 from "./janjiDatengModal.vue?vue&type=style&index=0&id=560ef316&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports